(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-catalog]').forEach((catalog) => {
    const chips = catalog.querySelectorAll('[data-catalog-filter]');
    const cards = catalog.querySelectorAll('[data-shop-category]');
    const groups = catalog.querySelectorAll('[data-catalog-group]');
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const filter = chip.dataset.catalogFilter;
        chips.forEach((item) => {
          const active = item === chip;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active.toString());
        });
        cards.forEach((card) => { card.hidden = filter !== 'all' && card.dataset.shopCategory !== filter; });
        groups.forEach((group) => { group.hidden = !Array.from(group.querySelectorAll('[data-shop-category]')).some((card) => !card.hidden); });
      });
    });
    catalog.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.currentTarget.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rove-landing"] && !Shopify.designMode) return;
  try {
    
function roveLandingClick(event) {
  const link = event.target.closest('[data-rl-texture], [data-rl-notify]');
  if (!link) return;

  const root = link.closest('.rl');
  const field = link.hasAttribute('data-rl-texture')
    ? root.querySelector('select[name="contact[Texture]"]')
    : root.querySelector('[data-rl-accessory]');

  if (!field) return;

  field.value = link.dataset.rlTexture || link.dataset.rlNotify;
  field.dispatchEvent(new Event('change', { bubbles: true }));

  requestAnimationFrame(() => field.focus({ preventScroll: true }));
}

document.addEventListener('click', roveLandingClick);

  } catch(e) { console.error(e); }
})();
})();
